import { CategoryPageTemplate } from './CategoryPageTemplate'

export function RegenerativePage() {
  return <CategoryPageTemplate categoryKey="regenerative" namespace="regenerative" />
}
